import React, { useEffect, useState } from "react";
import { Button, Card, Container, Row, Col, InputGroup, FormControl, Form, Image, Modal } from "react-bootstrap";
import ReactCodeInput from "react-code-input";
import { NavLink, useNavigate,useSearchParams } from "react-router-dom";
import { css } from "@emotion/react";
import { useSpring, animated } from 'react-spring'
import { apiUrl } from "../commons/inFormTypes";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loaders from '../components/Loaders';
// import Logo4x from '../assets/img/Logo4x.png';
import recycling from '../assets/img/recycle10.png';
import { handleEnter } from "../components/CommonFunections";
//  import { Version } from '../commons/inFormTypes'
import { useTimer } from 'use-timer';
import BigLoaders from "../components/BigLoaders";

const props = {
  className: ReactCodeInput,
  inputStyle: {
    fontFamily: 'Yekan Bakh Fa 05 Medium',
    // fontFamily: 'monospace',
    borderRadius: '6px',
    border: '1px solid lightgrey',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px 0px',
    margin: '3px',
    paddingLeft: '8px',
    width: '50px',
    height: '50px',
    fontSize: '32px',
    boxSizing: 'border-box',
    color: 'black',
    backgroundColor: 'white',
  }
}


function Login() {
  const [bigSnip, setBigSnip] = useState(false)
  const [forget, setForget] = useState(true);
  const [show, setShow] = useState(false);
  const [isnewCustomer, setIsnewCustomer] = useState(true);
  const [personType, setPersonType] = useState(0);
  const [checkPearson, setCheckPearson] = useState(false);
  const [orgPass, setOrgPass] = useState("");
  const [orgName, setOrgName] = useState("");
  const [orgCode, setOrgCode] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [visibility, setVisibility] = useState(false);
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [visibility1, setVisibility1] = useState(false);
  const [check, setCheck] = useState(false);
  const [errorMobile, setErrorMobile] = useState("");
  const [mobile, setMobile] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [codeError, setcodeError] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [codeMeli, setCodeMeli] = useState("");
  const [codeMeliError, setCodeMeliError] = useState("");
  const [snip, setSnip] = useState(false);
  const [snipMain, setSnipMain] = useState(false);
  const [formIsValid, setFormIsValid] = useState("1");
  const [rightMenuVisible, setRightMenuVisible] = useState(false);
  const [rightCodeVisible, setrightCodeVisible] = useState(false);
  const [rightRegVisible, setRegMenuVisible] = useState(false);
  const [token, setToken] = useState("");
  const userToken = localStorage.getItem("user_token");
  const [searchParams, setSearchParams] = useSearchParams();
  const promptToken = searchParams.get('Usertoken');
  const promptCode = searchParams.get('code');
  const navigate = useNavigate();
  const axios = require("axios");

  const { time, start, status, reset } = useTimer({initialTime: 200, timerType: 'DECREMENTAL',endTime: 0,
   // onTimeOver: () => {
    //   alert('Time is over');
    // }, 
  });
  
  

  useEffect(() => {
    if (promptToken === null) {
      if (userToken !== null) {
        navigate("/admin/dashboard");
      } else {
        navigate("/");
      }
    } else if(promptToken !== null) {
      setBigSnip(true)
      axios.post(apiUrl + `VerifyUserByToken?Token=${promptToken}`      
      )
      .then((res) => { 
        setBigSnip(false)                      
        if (res.data.result === "true") {     
             localStorage.setItem("user_namefamily", res.data.data.Name);
             localStorage.setItem("user_token", res.data.data.TokenId);
             navigate("/admin/dashboard");
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          navigate("/");
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  },[])

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submitAnimation = useSpring({
    opacity: rightMenuVisible ? 0 : 1,
    transform: rightMenuVisible ? `translateX(100%)` : `translateX(0)`,
  });

  const loginAnimation = useSpring({
    opacity: rightMenuVisible ? 1 : 0,
    transform: rightMenuVisible ? `translateX(0)` : `translateX(100%)`,
  });

  const codeAnimation = useSpring({
    opacity: rightCodeVisible ? 1 : 0,
    transform: rightCodeVisible ? `translateX(0)` : `translateX(100%)`,
  });

  // const codeAnimation1 = useSpring({
  //   opacity: rightCodeVisible ? 1 : 0,
  //   transform: rightCodeVisible ? `translateX(0)` : `translateX(100%)`,
  // });

  const registerAnimation = useSpring({
    opacity: rightRegVisible ? 1 : 0,
    transform: rightRegVisible ? `translateX(0)` : `translateX(100%)`,
  });

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
    setVisibility(visibility ? false : true);
  };

  const togglePasswordVisiblity1 = () => {
    setPasswordShown1(passwordShown1 ? false : true);
    setVisibility1(visibility1 ? false : true);
  };


  const submitHandler = (val) => {
    start()
    if (mobile.length < 10 || mobile === "" || mobile.length > 10) {
      setErrorMobile("لطفا شماره موبایل صحیح را وارد کنید");
      return false;
    } else {

      const axios = require("axios");

      val === true ? setSnipMain(true) : setSnip(true);
      val === true && setrightCodeVisible(!rightCodeVisible);
      var data = new FormData();
      var mb = 0 + mobile

      axios.post(apiUrl + "Login", val === true ? {
        mobile: mb,
        type: "Forget"
      }
        :
        {
          mobile: mb,
          type: ""
        }
      )
        .then((res) => {
          val === true ? setSnipMain(false) : setSnip(false);
          if (res.data.result === "true") {
            setToken(res.data.data)
            setForget(res.data.IsForgetpassword)
            setIsnewCustomer(res.data.IsnewCustomer);
            setRightMenuVisible(!rightMenuVisible);
            setrightCodeVisible(true);
            setFormIsValid("2");
          }
          else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          setSnip(false);
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };


  const inputHandle = pinCode => {
    setPinCode(pinCode);
  };

  const loginHandler = (e) => {
    e.preventDefault();
    if (pinCode === "") {
      setcodeError("لطفا کد صحیح را وارد کنید");
      return false;
    }
    if (forget === true) {
      setShow(true)
    } else {
      const axios = require("axios");
      setSnip(true);
      var mb = 0 + mobile
      //setMobile(0 + mobile)
      isnewCustomer === true || forget === true
        ?

        (axios
          .post(apiUrl + "CheckCode", {
            Code: pinCode,
            TokenId: token,
            Mobile: mb,

          })
          .then((res) => {
            setSnip(false);
            if (res.data.result === "true") {
              setPinCode("");
              if (res.data.Isnewcustomer) {
                setRegMenuVisible(!rightRegVisible)
                setFormIsValid("3");
              } else {
                localStorage.setItem("user_namefamily", res.data.data.Name);
                localStorage.setItem("user_token", res.data.data.TokenId);
                navigate("/admin/dashboard");
              }
            } else {
              toast.error(res.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .catch(function (error) {
            setSnip(false);
            if (error.response) {
              toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
        )
        :
        (

          axios
            .post(apiUrl + "Checkuser", {
              Code: pinCode,
              TokenId: token,
              Mobile: mb,
            })
            .then((res) => {
              setSnip(false);
              if (res.data.result === "true") {
                localStorage.setItem("user_namefamily", res.data.data.Name);
                localStorage.setItem("user_token", res.data.data.TokenId);
                // localStorage.setItem("version", Version);
                navigate("/admin/dashboard");
              } else {
                toast.error(res.data.message, {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            })
            .catch(function (error) {
              setSnip(false);
              if (error.response) {
                toast.error(error.response.data.message, {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            })

        )
    }
  }

  //this is function of register
  const registerHandler = (e) => {
    e.preventDefault();
    if (personType === 0 && (name === "" || codeMeli === "" || codeMeli.length < 10 || codeMeli.length > 10 ||
      password === "" || password.length < 6)) {
      toast.error("لطفا اطلاعات صحیح را وارد نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return;
    } else if (personType > 0 && (orgName === "" || orgCode === "" || orgPass === "" || orgPass.length < 6)) {
      toast.error("لطفا اطلاعات صحیح را وارد نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return;
    } else {
      const axios = require("axios");
      setSnip(true);
      var mb = 0 + mobile
      axios
        .post(apiUrl + "Register", personType === 0 ? {
          mobile: mb,
          Codemelli: codeMeli,
          FirstName: name,
          TokenId: token,
          Type: personType,
          Password: password,
        }
          :
          {
            mobile: mb,
            Codemelli: orgCode,
            FirstName: orgName,
            TokenId: token,
            Type: personType,
            Password: orgPass,
          }
        )
        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            localStorage.setItem("user_namefamily", res.data.data.Name);
            localStorage.setItem("user_token", res.data.data.TokenId);
            // localStorage.setItem("version", Version);
            navigate("/admin/dashboard");
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          setSnip(false);
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }

  }

  const handleNewPassword = () => {
    if (password.length < 6 || password === "" || orgPass === "") {
      toast.error("لطفا رمز عبور صحیح را وارد کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    else if (password !== orgPass) {
      toast.error("رمز عبور یکسان نمیباشد", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setSnipMain(true);
      axios
        .post(apiUrl + "Register_Pass", {
          TokenId: token,
          Password: password,
        }
        )
        .then((res) => {
          setSnipMain(false);
          if (res.data.result === "true") {
            localStorage.setItem("user_namefamily", res.data.data.Name);
            localStorage.setItem("user_token", res.data.data.TokenId);
            navigate("/admin/dashboard");
            setShow(false)
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          setSnip(false);
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });

    }
  }


  //enter for input insted of click button submitHandler function
  const keyPress = (e, val) => {
    if (e.keyCode === 13) {
      switch (val) {
        case 0:
          submitHandler(e)
          break;

        case 1:
          loginHandler(e);
          break;

        case 2:
          handleNewPassword(e);
          break;

        default:
          break;
      }
    }
  }


  // change mobile number
  const backHandler = () => {
    reset();
    setPinCode("");
    setFormIsValid("1");
    setRightMenuVisible(false);
    setrightCodeVisible(!rightCodeVisible)
    setErrorMobile("")
    setMobile("");
  }

  //select type persons
  const RadioHandlerChange = (val) => {
    if (val === "0") {
      setCheckPearson(false)
      setPersonType(val)
    } else if (val === "1") {
      setCheckPearson(true)
      setPersonType(val)
    }
  }


  return (
    <div>
      <div className="rgc-style loginStyle">
        <section>
          <Container className="position-relative">
          <BigLoaders loads={bigSnip} />
            <Row className="d-flex justify-content-center align-items-center">
              <Col xs={12} md={8} lg={6} xl={5} className="rgc-login-style">


                <Card className="rgc-login-card shadow-2-strong">
                  <Card.Body className="text-center">
                    <div className="rgc-login-header mb-3">
                      {/* <Avatar
                        className="fa fa-user-circle rgc-avatar-log"
                        size="large"
                        src=""
                      /> */}
                      <Image src={recycling} alt="logo" className="rgc-logo-login" />
                      <div className="rgc-login-title my-3">
                        <p>سامانه یکپارچه - پسماند شهرداری آمل </p>
                        <h2>زیستماند</h2>
                      </div>
                    </div>

                    <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                      <animated.div style={submitAnimation}>
                        <InputGroup className="mb-1 rgc-input">
                          <InputGroup.Text id="basic-addon1" className="rgc-code">+98</InputGroup.Text>
                          <FormControl
                            className="rgc-code"
                            placeholder="912 *** ***"
                            aria-label="phoneNumber"
                            aria-describedby="basic-addon1"
                            type="number"
                            value={mobile}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}//you can enter just number
                            onChange={(event) =>
                              setMobile(event.target.value)
                            }
                            onKeyDown={(event) => keyPress(event, 0)}
                          />
                        </InputGroup>
                        <small id="userHelp" className="text-danger form-text">
                          {errorMobile}
                        </small>

                      </animated.div>

                      <Button
                        type="button"
                        className="btn-fill my-4 rgc-btn"
                        onClick={submitHandler}
                        variant="btn"
                      >
                        <Loaders loads={snip} />
                        <span> مرحله بعدی</span>
                      </Button>
                    </div>

                    <div className={formIsValid === "2" ? "d-block" : "d-none"}>

                      {isnewCustomer === true || forget === true ?
                        <animated.div style={codeAnimation}>
                          <ReactCodeInput
                            className="pinCodeClass"
                            {...props}
                            id="pinCode"
                            type="number"
                            fields={4}
                            filterChars='-'
                            value={pinCode}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onChange={inputHandle}
                          />                         
                          <div  className="d-block">
                            <i class='fas fa-stopwatch'></i>
                            <span>زمان باقیمانده:</span>
                            <span>{time}</span>
                          </div>
                        </animated.div>
                        :
                        <animated.div style={loginAnimation}>
                          <Form.Group className="rgc-input-icons rgc-profile-input-pass" controlId="formBasicCode">
                            <span onClick={togglePasswordVisiblity1}>
                              {visibility1 ? <i className="fa fa-eye" aria-hidden="true" ></i> :
                                <i className="fa fa-eye-slash" aria-hidden="true"></i>
                              }
                            </span>
                            <Form.Control
                              autoComplete="off"
                              type={passwordShown1 ? "text" : "password"}
                              placeholder="رمز عبور"
                              className="rgc-profile-input"
                              value={pinCode}
                              onChange={(event) => setPinCode(event.target.value)}
                              //  onKeyDown={handleEnter}
                              onKeyDown={(event) => keyPress(event, 1)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                        </animated.div>
                      }
                      <br />

                      <Button
                        type="submit"
                        className="btn-fill my-3 rgc-btn"
                        onClick={loginHandler}
                        variant="btn"
                      >
                        <Loaders loads={snip} />
                        <span>ورود/ثبت نام </span>
                      </Button>

                      {(isnewCustomer === false && forget === false) &&
                        <span
                          type="submit"
                          className="rgc-back-icon-danger"
                          onClick={() => submitHandler(true)}
                          variant="btn btn-danger"
                        >
                          <i className='fas fa-share rgc-back-icon'></i>
                          <span>فراموشی رمز عبور</span>
                          {/* <Loaders loads={true} /> */}
                        </span>
                      }
                      <br />
                      <span
                        type="submit"
                        className="rgc-back-btn mt-2"
                        onClick={backHandler}
                        variant="btn btn-danger"
                      >
                        <i className='fas fa-share rgc-back-icon'></i>
                        <span>تغییر شماره همراه</span>
                      </span>

                    </div>

                    <div className={formIsValid === "3" ? "d-block" : "d-none"}>
                      <Form.Group controlId="formBasicCheckbox" className="row g-0 justify-content-center py-2">
                        <Form.Check
                          className="rgc-form-check-select col-5 text-end"
                          // checked={check1 === '1'}
                          // checked={true}
                          defaultChecked
                          label="اشخاص حقیقی"
                          inline
                          name="group1"
                          type="radio"
                          id={0}
                          value={0}
                          onChange={(e) => RadioHandlerChange(e.target.value)}
                        />

                        <Form.Check
                          className="rgc-form-check-select col-5 text-end"
                          // checked={check1 === '2'}
                          label="سازمان ها و موسسات "
                          inline
                          name="group1"
                          type="radio"
                          id={1}
                          value={1}
                          onChange={(e) => RadioHandlerChange(e.target.value)}
                        />
                      </Form.Group>

                      {/* pearsons */}
                      <animated.div style={registerAnimation}>
                        <div className={checkPearson === false ? "d-block" : "d-none"}>
                          <Form className="text-end rgc-register">

                            <Form.Group className="rgc-input-icons" controlId="formBasicName">
                              <Form.Label>نام و نام خانوادگی</Form.Label>
                              <i className='fas fa-user-alt'></i>
                              <Form.Control
                                autoComplete="off" //delete suggest words
                                type="text"
                                placeholder="نام و نام خانوادگی"
                                className="rgc-profile-input"
                                value={name}
                                onChange={(event) =>
                                  setName(event.target.value)
                                }
                                onKeyDown={handleEnter}
                              />
                            </Form.Group>
                            <small id="userHelp" className="text-danger form-text">
                              {nameError}
                            </small>
                            <br />


                            <Form.Group className="rgc-input-icons" controlId="formBasicCode">
                              <Form.Label>کد ملی</Form.Label>
                              <i className="fa fa-id-card" aria-hidden="true"></i>
                              <Form.Control
                                autoComplete="off"
                                type="number"
                                placeholder="کد ملی"
                                className="rgc-profile-input"
                                value={codeMeli}
                                onChange={(event) =>
                                  setCodeMeli(event.target.value)
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onKeyDown={handleEnter}
                              />
                            </Form.Group>


                            <small id="userHelp" className="text-danger form-text">
                              {codeMeliError}
                            </small>
                            <br />

                            <Form.Group className="rgc-input-icons" controlId="formBasicCode">
                              <Form.Label>رمز عبور </Form.Label>
                              <span onClick={togglePasswordVisiblity}>
                                {visibility ? <i className="fa fa-eye" aria-hidden="true" ></i> :
                                  <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                }
                              </span>
                              <Form.Control
                                autoComplete="off"
                                type={passwordShown ? "text" : "password"}
                                placeholder="رمز عبور"
                                className="rgc-profile-input"
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                                onKeyDown={handleEnter}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>

                            <small id="userHelp" className="text-info form-text">
                              {/* {passwordError} */}
                              رمز عبور باید شش رقمی باشد
                            </small>

                          </Form>
                          <br />
                        </div>
                      </animated.div>

                      {/* organization */}
                      <div className={checkPearson === true ? "d-block" : "d-none"}>
                        <Form className="text-end rgc-register">
                          <Form.Group className="rgc-input-icons" controlId="formBasicName">
                            <Form.Label>نوع سازمان/موسسه</Form.Label>
                            <Form.Select
                              aria-label="Default select example"
                              className="rgc-select"
                              value={personType}
                              onChange={(e) => setPersonType(e.target.value)}
                            >
                              <option value="1">بانک ها</option>
                              <option value="2">موسسات خیریه</option>
                              <option value="3">سازمان ها</option>
                            </Form.Select>
                          </Form.Group>
                          <br />

                          <Form.Group className="rgc-input-icons" controlId="formBasicName">
                            <Form.Label>شناسه سازمان/موسسه</Form.Label>
                            <i className='fas fa-user-alt'></i>
                            <Form.Control
                              autoComplete="off"
                              type="number"
                              placeholder="شناسه سازمان/موسسه"
                              className="rgc-profile-input"
                              value={orgCode}
                              onChange={(event) => setOrgCode(event.target.value)}
                              onKeyDown={handleEnter}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                          {/* <small id="userHelp" className="text-danger form-text">
                            {nameError}
                          </small> */}
                          <br />


                          <Form.Group className="rgc-input-icons" controlId="formBasicCode">
                            <Form.Label>عنوان </Form.Label>
                            <i className="fa fa-id-card" aria-hidden="true"></i>
                            <Form.Control
                              autoComplete="off"
                              type="text"
                              placeholder="عنوان "
                              className="rgc-profile-input"
                              value={orgName}
                              onKeyDown={handleEnter}
                              onChange={(event) =>
                                setOrgName(event.target.value)
                              }
                            />
                          </Form.Group>
                          {/* <small id="userHelp" className="text-danger form-text">
                            {codeMeliError}
                          </small> */}
                          <br />

                          <Form.Group className="rgc-input-icons" controlId="formBasicCode">
                            <Form.Label>رمز عبور </Form.Label>
                            <span onClick={togglePasswordVisiblity1}>
                              {visibility1 ? <i className="fa fa-eye" aria-hidden="true" ></i> :
                                <i className="fa fa-eye-slash" aria-hidden="true"></i>
                              }
                            </span>
                            <Form.Control
                              autoComplete="off"
                              type={passwordShown1 ? "text" : "password"}
                              placeholder="رمز عبور"
                              className="rgc-profile-input"
                              value={orgPass}
                              onKeyDown={handleEnter}
                              onChange={(event) => setOrgPass(event.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>


                          <small id="userHelp" className="text-info form-text">
                            {/* {passwordError} */}
                            رمز عبور باید شش رقمی باشد
                          </small>

                        </Form>
                        <br />
                      </div>

                      <Col xs={12} className="text-end mb-2">
                        <Form.Check
                          checked={check}
                          key={1}
                          inline
                          name="group1"
                          type="switch"
                          id={1}
                          onChange={(e) => setCheck(e.target.checked)}
                          className="rgc-switch"
                          label="تمامی قوانین و مقررات این سامانه را میپذیرم"
                        />
                      </Col>
                      {check ?
                        <Button
                          type="submit"
                          className="btn-fill m-1 rgc-btn"
                          onClick={registerHandler}
                          variant="btn"
                        >
                          <Loaders loads={snip} />
                          <span>ورود</span>
                        </Button>
                        :
                        <Button
                          disabled
                          type="submit"
                          className="btn-fill m-1 rgc-btn"
                          onClick={registerHandler}
                          variant="btn"
                        >
                          <Loaders loads={snip} />
                          <span>ورود   </span>
                        </Button>
                      }
                    </div>
                    <hr />
                    <div className="test">
                      <div className="rgc-social d-flex flex-row align-items-center justify-content-center">
                        <a href="">
                          <i className="fab fa-instagram" aria-hidden="true"></i>
                        </a>
                        <a href="">
                          <i class="fa-brands fa-telegram"></i>
                        </a>
                        <a href="">
                          <i class="fa-brands fa-whatsapp"></i>
                        </a>
                        <hr className="my-2" />
                      </div>
                    </div>
                    <hr className="my-2" />
                    <NavLink to="/appguidance" aria-current="page" className="rgc-link">
                      {" "}
                      راهنمای اپلیکیشن
                    </NavLink>

                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* enter new password */}
            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}

            >
              <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex flex-column text-end rgc-modal-content">
                  {/* <div>
                    <Image src={logo1} alt="logo" />
                  </div> */}


                  <Form.Group className="rgc-input-icons mb-3" controlId="formBasicCode">
                    <Form.Label>رمز عبور </Form.Label>
                    <span onClick={togglePasswordVisiblity}>
                      {visibility ? <i className="fa fa-eye" aria-hidden="true" ></i> :
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                      }
                    </span>
                    <Form.Control
                      autoComplete="off"
                      type={passwordShown ? "text" : "password"}
                      placeholder="رمز عبور"
                      className="rgc-profile-input"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      onKeyDown={handleEnter}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="rgc-input-icons my-2" controlId="formBasicCode">
                    <Form.Label>تکرار رمز عبور </Form.Label>
                    <span onClick={togglePasswordVisiblity1}>
                      {visibility1 ? <i className="fa fa-eye" aria-hidden="true" ></i> :
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                      }
                    </span>
                    <Form.Control
                      autoComplete="off"
                      type={passwordShown1 ? "text" : "password"}
                      placeholder="تکرار رمز عبور"
                      className="rgc-profile-input"
                      value={orgPass}
                      onChange={(event) => setOrgPass(event.target.value)}
                      //  onKeyDown={handleEnter}
                      onKeyDown={(event) => keyPress(event, 2)}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Form.Group>

                  <small id="userHelp" className="text-info form-text">
                    رمز عبور باید شش رقمی باشد
                  </small>
                </div>
              </Modal.Body>

              <Modal.Footer className="rgc-modal-button">
                <Button
                  className="rgc-order-btns  rgc-order-btn-sub"
                  onClick={handleNewPassword}
                >
                  <Loaders loads={snipMain} />
                  <span>تایید </span>
                </Button>
              </Modal.Footer>
            </Modal>    
          </Container>
          <div className="rgc-toast">
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              className="rgc-toast"
            />
          </div>
        </section>
      </div>
    </div>
  );
}
export default Login;